import { useNavigate } from 'react-router-dom';

const POLICY_SECTIONS = [
  {
    title: '1. Общие положения',
    text: 'Настоящая Политика конфиденциальности определяет порядок обработки персональных данных пользователей бота в мессенджере Telegram (далее — «Бот»), принадлежащего ИП Алексеева О.А. Используя Бот, вы соглашаетесь с условиями данной политики.',
  },
  {
    title: '2. Какие данные мы обрабатываем',
    text: 'При использовании Бота мы можем обрабатывать: идентификатор пользователя Telegram (telegram_id), имя пользователя (username), имя и фамилию из профиля Telegram; номер телефона и адрес доставки, которые вы указываете при оформлении заказа; историю заказов и начисление бонусов. Данные необходимы для приёма и выполнения заказов, связи с вами и работы программы лояльности.',
  },
  {
    title: '3. Цели обработки',
    text: 'Персональные данные используются для: приёма и исполнения заказов на доставку цветов; связи с вами по вопросам заказа; начисления и списания бонусов; улучшения работы сервиса и качества обслуживания.',
  },
  {
    title: '4. Хранение и защита данных',
    text: 'Данные хранятся на защищённых серверах в соответствии с применимым законодательством. Мы принимаем разумные меры для защиты персональных данных от несанкционированного доступа, изменения или уничтожения.',
  },
  {
    title: '5. Передача данных третьим лицам',
    text: 'Мы можем передавать данные партнёрам, необходимым для исполнения заказа (например, курьерским службам, платёжным системам). Передача осуществляется в объёме, необходимом для указанных целей.',
  },
  {
    title: '6. Ваши права',
    text: 'Вы вправе запросить доступ к своим данным, их уточнение, удаление или ограничение обработки. Для этого обратитесь к нам по контактам, указанным в разделе «О нас» в Боте.',
  },
  {
    title: '7. Изменения политики',
    text: 'Мы можем обновлять настоящую Политику конфиденциальности. Актуальная версия всегда доступна по кнопке «Правила» в Боте. Продолжение использования Бота после изменений означает ваше согласие с обновлённой политикой.',
  },
  {
    title: '8. Контакты',
    text: 'По вопросам обработки персональных данных и данной политики вы можете связаться с нами по контактам, указанным в разделе «О нас» в приложении (телефон, email).',
  },
];

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: '16px',
        paddingBottom: '32px',
        maxWidth: '600px',
        margin: '0 auto',
        color: 'var(--text-primary)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            padding: '8px',
            cursor: 'pointer',
            color: 'var(--color-accent)',
            fontSize: '14px',
          }}
        >
          ← Назад
        </button>
        <h1 style={{ fontSize: '20px', fontWeight: 600, margin: 0 }}>
          Политика конфиденциальности
        </h1>
      </div>

      <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '20px' }}>
        Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
      </p>

      {POLICY_SECTIONS.map((section) => (
        <section key={section.title} style={{ marginBottom: '20px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
            {section.title}
          </h2>
          <p style={{ fontSize: '14px', lineHeight: 1.5, margin: 0 }}>{section.text}</p>
        </section>
      ))}
    </div>
  );
}
